/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../components/SmoothScroll";

const AntiDiscr = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
  <div>
      <title>
       Anti - Discrimination Policy | Citrus Diagnostic Center
      </title>
      <meta
        name="description"
        content="Our Anti-Discrimination Policy promotes equal opportunity, fairness, and respect for all patients, visitors, and employees at Citrus Diagnostic Center today."
      />
    <div className="flex justify-center items-center pt-48 lg:pt-[14.0625rem]">
      <div className="w-4/5  flex flex-col items-center  pb-8 lg:pb-16">
        <h1
          data-aos="fade-up"
          data-aos-delay="100"
          className="font-robout lg:text-5xl text-[#d78558] text-3xl lg:pb-20 capitalize leading-tight md:md:text-left text-center sm:leading-snug font-black"
        >
          ANTI-DISCRIMINATION POLICY – Discrimination is Against The Law
        </h1>
        <div className="md:text-left text-center">
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 py-16 md:text-left text-center font-robout">
            Citrus Diagnostic Center complies with applicable Federal civil
            rights laws and do not discriminate, exclude people, or treat them
            differently on the basis of race, color, national origin, age,
            disability or sex, including discrimination based on pregnancy,
            gender identity and sex stereotyping.
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-8  md:text-left text-center font-robout">
            Our center provides free aids and services to people with
            disabilities to communicate effectively with us, such as qualified
            sign language interpreters, written information in other formats,
            and free language services to people whose primary language is not
            English, such as qualified interpreters and information written in
            other languages.
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-8  md:text-left text-center font-robout">
            If you need these services, please notify imaging center staff and
            our schedulers when making future appointments.
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-8  md:text-left text-center font-robout">
            If you believe that this facility has failed to provide services or
            discriminated against you in another way on the basis above, you can
            file a grievance with:
          </p>

          <h2 className="xl:text-[1.8rem] md:text-2xl text-lg text-[#d78558]  font-bold lg:ps-0 md:px-8 px-4 py-10">
            Compliance Grievance Coordinator Hotline: (844) 895-6650
          </h2>

          <p className="md:text-2xl text-lg text-[#d78558] lg:ps-0 font-bold  md:px-8 px-4 py-10">
            U.S. Department of Health and Human Services, Office for Civil
            Rights
          </p>
          <h2 className="xl:text-[1.8rem] md:text-2xl text-lg text-[#d78558]   text-left   font-bold lg:ps-0 md:px-8 px-4 py-10">
            Online Complaint Portal:{" "}
            <a
              className="text-white underline"
              href="https://ocrportal.hhs.gov/ocr/portal/lobby.jsf"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://ocrportal.hhs.gov/ocr/portal/lobby.jsf Opens in New Window
            </a>
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left  font-robout">
            Mailing Address:
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4    text-left   font-robout">
            U.S. Dept of HHS, OIG
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4    text-left   font-robout">
            200 Independence Avenue, SW
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4     text-left   font-robout">
            Room 509F, HHH Building
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4     text-left   font-robout">
            Washington, D.C. 20201
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4    text-left   font-robout">
            Phone:{" "}
            <a href="tel:8003681019" className="underline">
              (800)-368-1019
            </a>{" "}
            ,{" "}
            <a href="tel:8005377697" className="underline">
              (800)-537-7697
            </a>{" "}
            (TDD)
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4    text-left   font-robout">
            Complaint forms available at:{" "}
            <a
              className="text-white underline"
              href="http://www.hhs.gov/ocr/office/file/"
              target="_blank"
              rel="noreferrer noopener"
            >
              http://www.hhs.gov/ocr/office/file/ Opens in New Window
            </a>
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4     text-left   font-robout">
            Washington, D.C. 20201
          </p>
        </div>
      </div>
    </div>
  </div>
  );
};

export default AntiDiscr;
